import React from 'react';
import { FiGlobe, FiInstagram } from 'react-icons/fi';
import { MessengerIcon } from '../icons/MessengerIcon';
import './metaConversation.css';

export type MetaBadgeChannel = 'instagram' | 'messenger' | 'webchat';

interface Props {
  channel: MetaBadgeChannel;
  /** "Instagram · @conta"; sem ele, só o nome do canal. */
  label?: string | null;
  compact?: boolean;
  /** Só o ícone (prévia da lista, onde o texto já diz "Instagram: …"). */
  iconOnly?: boolean;
}

/** Selo do canal da Meta na mensagem e na prévia da lista: "Instagram · @conta". */
export const ChannelBadge: React.FC<Props> = ({ channel, label, compact, iconOnly }) => {
  const name = channel === 'instagram' ? 'Instagram' : channel === 'webchat' ? 'Site' : 'Messenger';
  const iconProps = {
    size: compact ? 11 : 12,
    'aria-hidden': iconOnly ? undefined : true,
    'aria-label': iconOnly ? label || name : undefined,
  } as const;
  return (
    <span className={`channel-badge channel-badge-${channel}${compact ? ' channel-badge-compact' : ''}`} data-channel={channel} title={label || name}>
      {channel === 'messenger' ? (
        <MessengerIcon {...iconProps} role={iconOnly ? 'img' : undefined} />
      ) : channel === 'instagram' ? (
        <FiInstagram {...iconProps} />
      ) : (
        <FiGlobe {...iconProps} />
      )}
      {!iconOnly && <span className="channel-badge-text">{label || name}</span>}
    </span>
  );
};
